import { ViewportScroller } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ModalAddAccountComponent } from 'src/app/modules/user-management/modal-add-account.component';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ActivityService } from '../../activity.service';

@Component({
  selector: 'app-register-consult-dialog',
  templateUrl: './register-consult-dialog.component.html',
  styleUrls: ['./register-consult-dialog.component.scss']
})
export class RegisterConsultDialogComponent implements OnInit {
  modalData: any;
  registerForm: FormGroup;
  token: string;
  waitPay: boolean = false;
  waitConfirm: boolean = false;
  payReject: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalAddAccountComponent>,
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private viewportScroller: ViewportScroller,
    private cookieService: CookieService,
    private activityService: ActivityService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.modalData = data;
    // // console.log(data);

    if (this.modalData.data.STATUS_PAY === 'waiting_pay') this.waitPay = true;
    if (this.modalData.data.STATUS_PAY === 'waiting_confirm') this.waitConfirm = true;
    if (this.modalData.data.STATUS_PAY === 'reject') this.payReject = true;

    this.registerForm = fb.group({
      solution: [this.modalData.data.CONSULT_DETAIL.CONSULT_SOLUTION, Validators.required],
      joinType: ['', Validators.required],
      countRegis: [1, Validators.required],
      moreDetail: ['']
    });
    if (this.waitPay || this.waitConfirm) {
      this.registerForm = fb.group({
        solution: [this.modalData.data.CONSULT_DETAIL.CONSULT_SOLUTION, Validators.required],
        joinType: [this.modalData.data.CONSULT_JOIN_TYPE, Validators.required],
        countRegis: [this.modalData.data.CONSULT_DETAIL.CONSULT_REGISTER, Validators.required],
        moreDetail: [this.modalData.data.MORE_DETAIL]
      });
    }
  }

  ngOnInit(): void {
    this.token = this.cookieService.get('token');
  }

  closeModal() {
    const response = {
      status: false,
      value: {}
    }

    this.dialogRef.close(response);
  }

  confirmRegister(r, m) {
    const dialogConfig = new MatDialogConfig();

    // // console.log(r);
    // // console.log(m);

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    // dialogConfig.width = '500px';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      title: 'ยืนยันการจอง',
      actionBtnText: 'ยืนยันการจอง',
      cancleBtnText: 'ยกเลิก',
      description: `โปรดเช็คความถูกต้องของข้อมูล เนื่องจาก<b class="text-danger">ไม่สามารถแก้ไขข้อมูลได้</b>หลังจากการจอง`
    }

    if (m.data.CONSULT_DETAIL.CONSULT_TYPE === 'ส่วนตัว') {
      if (r.countRegis > 0) {
        const modal = this.matDialog.open(ModalComponent, dialogConfig);

        modal.afterClosed().pipe(
          switchMap(res => {
            if (res) {
              const body = {
                CONSULT_ID: m.data.CONSULT_DETAIL.CONSULT_ID,
                CONSULT_UNIT_PRICE: m.data.CONSULT_DETAIL.CONSULT_UNIT_PRICE,
                CONSULT_TOTAL_PRICE: this.getPrice(),
                CONSULT_TYPE: this.modalData.consultType,
                CONSULT_SOLUTION: r.solution,
                CONSULT_JOIN_TYPE: r.joinType,
                CONSULT_COUNT_REGISTER: r.countRegis,
                MORE_DETAIL: r.moreDetail,
                CONSULT_CATEGORY: this.modalData.searchData
              }

              return this.activityService.registerConsult(body).pipe(
                map((result) => {
                  let type = 'consult';
                  const queryParams: Params = { id: m.data.CONSULT_DETAIL.CONSULT_ID, type: type };
                  this.router.navigate(
                    ['/payment'],
                    {
                      relativeTo: this.route,
                      queryParams: queryParams,
                      queryParamsHandling: 'merge',
                    });
                  this.dialogRef.close({ status: true, value: { result } })
                })
              );
            } else {
              return of(null)
            }
          }),
          catchError((err) => {
            // console.log(err);
            alert(err.error.message)
            return of(null);
          }),
          map(result => {
            if (result) {
              this.dialogRef.close({ status: true, value: { result } })
            }
          })
        ).subscribe()
      } else {
        alert('จำนวนผู้เข้าร่วมไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง');
      }
    } else {
      if ((m.data.CONSULT_DETAIL.CONSULT_MAX - m.data.CONSULT_DETAIL.CONSULT_REGISTER) >= r.countRegis && r.countRegis > 0) {
        const modal = this.matDialog.open(ModalComponent, dialogConfig);

        modal.afterClosed().pipe(
          switchMap(res => {
            if (res) {
              const body = {
                CONSULT_ID: m.data.CONSULT_DETAIL.CONSULT_ID,
                CONSULT_UNIT_PRICE: m.data.CONSULT_DETAIL.CONSULT_UNIT_PRICE,
                CONSULT_TOTAL_PRICE: this.getPrice(),
                CONSULT_TYPE: this.modalData.consultType,
                CONSULT_SOLUTION: r.solution,
                CONSULT_JOIN_TYPE: r.joinType,
                CONSULT_COUNT_REGISTER: r.countRegis,
                MORE_DETAIL: r.moreDetail,
                CONSULT_CATEGORY: this.modalData.searchData
              }

              return this.activityService.registerConsult(body).pipe(
                map((result) => {
                  let type = 'consult';
                  const queryParams: Params = { id: m.data.CONSULT_DETAIL.CONSULT_ID, type: type };
                  this.router.navigate(
                    ['/payment'],
                    {
                      relativeTo: this.route,
                      queryParams: queryParams,
                      queryParamsHandling: 'merge',
                    });
                  this.dialogRef.close({ status: true, value: { result } })
                })
              );
            } else {
              return of(null)
            }
          }),
          catchError((err) => {
            // console.log(err);
            alert(err.error.message)
            return of(null);
          }),
          map(result => {
            // // console.log(result);
            if (result) {
              this.dialogRef.close({ status: true, value: { result } })
            }
          })
        ).subscribe()
      } else {
        alert('จำนวนผู้เข้าร่วมไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง');
      }
    }
  }

  payment() {
    let type = 'consult';
    const queryParams: Params = { id: this.modalData.data.CONSULT_DETAIL.CONSULT_ID, type: type };
    this.router.navigate(
      ['/payment'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge',
      });
    this.dialogRef.close({ status: true, value: {} })
  }

  openHistory() {
    this.router.navigate(['user-history'], { state: { statusPay: 'reject' } });
    this.dialogRef.close({ status: true, value: {} })
  }

  getTime(start, end) {
    let time = `${this.addZeroBefore(new Date(start).getHours())}:00 - ${this.addZeroBefore(new Date(end).getHours())}:00 น.`
    return time;
  }

  getPrice(): number {
    return (this.modalData.personOrGroup === 'ส่วนตัว') ? this.modalData.data.CONSULT_DETAIL.CONSULT_UNIT_PRICE : this.modalData.data.CONSULT_DETAIL.CONSULT_UNIT_PRICE === 0 ? 0 : this.modalData.data.CONSULT_DETAIL.CONSULT_UNIT_PRICE + (this.registerForm.value.countRegis * 250);
    // return ((this.registerForm.value.joinType === 'คนเดียว') || !this.registerForm.value.joinType) ? this.modalData.data.CONSULT_DETAIL.CONSULT_UNIT_PRICE : this.modalData.data.CONSULT_DETAIL.CONSULT_UNIT_PRICE === 0 ? 0 : this.modalData.data.CONSULT_DETAIL.CONSULT_UNIT_PRICE + ((this.registerForm.value.countRegis - 1) * 250);
  }

  clearJoinType() {
    this.registerForm.controls['countRegis'].setValue(1);
  }

  addZeroBefore(n) {
    return (n < 10 ? '0' : '') + n;
  }

  goToScroll(el: string) {
    this.viewportScroller.scrollToAnchor(el)
  }
}
